import * as React from "react";
import { FaShoppingBag, FaMotorcycle, FaUtensils, FaCalendarAlt } from "react-icons/fa";
import { PostmatesLogo } from "../icons/logos";
import { ShoppingBagFilled } from "../icons/order-icons-v2";
export const OrderIcon = (props) => {
    const { service, deliveryProvider, version } = props;
    switch (service) {
        case "pickup":
            if (version === 'v2') {
                return React.createElement(ShoppingBagFilled, null);
            }
            else {
                return React.createElement(FaShoppingBag, null);
            }
        case "delivery":
            switch (deliveryProvider) {
                case "postmates":
                    return React.createElement(PostmatesLogo, null);
                default:
                    return React.createElement(FaMotorcycle, null);
            }
        case "dine_in":
            return React.createElement(FaUtensils, null);
        case "table_booking":
            return React.createElement(FaCalendarAlt, null);
        default:
            return React.createElement(FaShoppingBag, null);
    }
};
//# sourceMappingURL=order-icon.js.map